import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

import { FileField } from 'Shared/form/FileField';
import SubmitButton from 'Shared/form/SubmitButton';
import { TextField } from 'Shared/form/TextField';
import { queryClient } from 'Shared/queryClient';

import { uploadPatientActivityFiles } from 'App/components/PatientProfile/PatientProfile.utils.js';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import useFetchPatientActivityFiles from 'App/hooks/useFetchPatientActivityFiles';

import summaryNotePropType from './types/summaryNotePropType';
import ClinicalNoteDownload from 'App/components/ClinicalNoteDownload';

const AttachmentEditModal = ({ onClose, note, existingAttachment }) => {
    const { patientId } = note;
    const { data: attachments } = useFetchPatientActivityFiles(patientId);

    return (
        <Modal show onHide={onClose}>
            <Modal.Header>
                <Modal.Title role="heading">{existingAttachment ? 'Attachment Update' : 'Attachment Upload'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={{
                    ...existingAttachment,
                    activity: note,
                }}
                onSubmit={async (values) => {
                    await uploadPatientActivityFiles(values, patientId);
                    queryClient.invalidateQueries(['patientActivity', patientId]);
                    onClose();
                }}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <TextField fieldName="description" label="Description" />
                            {!existingAttachment && (
                                <>
                                    <FileField fieldName="file" label="File" required />
                                    <div>Maximum size: {attachments?.uploadLimit}</div>
                                </>
                            )}

                            <div>
                                {note.attachments?.map((attachment) => (
                                    <div key={attachment.id}>
                                        <ClinicalNoteDownload file={attachment} />
                                    </div>
                                ))}
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <FormButtonGroup>
                                <Button variant="outline-secondary" onClick={onClose}>
                                    Close
                                </Button>
                                <SubmitButton>Upload</SubmitButton>
                            </FormButtonGroup>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

AttachmentEditModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    note: summaryNotePropType.isRequired,
    existingAttachment: PropTypes.shape({
        description: PropTypes.string,
    }),
};
AttachmentEditModal.defaultProps = {
    existingAttachment: null,
};

export default AttachmentEditModal;
